import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface TipsStatusAlertProps {
  error: string | null;
  isMockMode: boolean;
  onRefresh: () => void;
}

export function TipsStatusAlert({
  error,
  isMockMode,
  onRefresh,
}: TipsStatusAlertProps) {
  if (error) {
    return (
      <Alert variant='destructive' className='mb-4'>
        <AlertCircle className='h-4 w-4' />
        <AlertDescription>
          {error}
          <div className='flex gap-2 mt-2'>
            <Button variant='outline' size='sm' onClick={onRefresh}>
              Try Again
            </Button>
            <Button
              variant='outline'
              size='sm'
              onClick={() => alert('Mock mode not available')}
            >
              Use Mock Data
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    );
  }

  if (isMockMode) {
    return (
      <Alert className='mb-4'>
        <AlertCircle className='h-4 w-4' />
        <AlertDescription>
          Using sample data for demonstration. Actions like approve/reject will
          be simulated locally.
          <Button
            variant='outline'
            size='sm'
            onClick={() => alert('Mock mode not available')}
            className='ml-2'
          >
            Try Live API
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  return null;
}
